import { Collapse, Switch } from 'antd';
import { FormattedMessage } from 'react-intl';
// import TrackingInput from 'components/TrackingComponents/TrackingInput';
import { SwitchChangeEventHandler } from 'antd/lib/switch';
import RedInvoice from 'components/CreateStorePopup/components/RedInvoice';
import { SelectItem } from 'components/Select/Select';
import React, { FC } from 'react';
import styled from 'styled-components';
import utilsMessages from 'utils/messages';

interface VATInvoiceFormSectionProps {
  form: any;
  enabledVATInvoiceKey: boolean;
  onEnableGetVATInvoiceEvent: SwitchChangeEventHandler;
  resetDistrictAndWard: () => void;
  getDistrictsByCity: (city: string) => SelectItem[];
  resetWard: () => void;
  cities: SelectItem[];
  getWardsByCityAndDistrict: (city: string, district: string) => SelectItem[];
}

const { Panel } = Collapse;

const CustomPanel = styled(Panel)<any>`
  border-bottom: 0 !important;
  .ant-collapse-header {
    padding-left: 0 !important;
    padding-right: 0 !important;
    color: #595959 !important;
  }
  .ant-collapse-content-box {
    padding: 0 !important;
  }
  .ant-collapse-item {
    border-bottom: 0 !important;
  }

  .ant-collapse-arrow {
    right: 0 !important;
  }

  .ant-collapse-header {
    cursor: default !important;
  }
`;

const RedInvoiceWrapper = styled.div`
  #first-row {
    flex-direction: column;
    & > div {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

const VATInvoiceFormSection: FC<VATInvoiceFormSectionProps> = (props) => {
  const { enabledVATInvoiceKey, onEnableGetVATInvoiceEvent, form } = props;

  return (
    <Collapse
      bordered={false}
      expandIcon={() => <Switch checked={enabledVATInvoiceKey} onChange={onEnableGetVATInvoiceEvent} />}
      expandIconPosition="end"
      activeKey={[enabledVATInvoiceKey ? 'VATInvoicePanel' : '']}
      style={{ backgroundColor: 'unset' }}
    >
      <CustomPanel
        header={<FormattedMessage {...utilsMessages.getVATInvoiceOrNot} />}
        collapsible="disabled"
        key="VATInvoicePanel"
      >
        {enabledVATInvoiceKey ? (
          <RedInvoiceWrapper>
            <RedInvoice form={form} required={true} />
          </RedInvoiceWrapper>
        ) : null}
      </CustomPanel>
    </Collapse>
  );
};

export default VATInvoiceFormSection;
